import * as React from 'react';
import { Button, ButtonProps } from './Button';

type Props = {
  active?: boolean;
  disabled?: boolean;
  variant: string;
  dataOptions?: string;
};

type FilterButtonProps = Pick<ButtonProps, 'onClick' | 'children' | 'type'> & Props;

export const FilterButton = React.forwardRef<HTMLButtonElement, any>(function FilterButton(
  {
    active,
    type,
    children,
    dataOptions,
    variant = 'secondaryFilter',
    disabled = false,
    ...props
  }: FilterButtonProps,
  ref
) {
  let newDataOptions = dataOptions ? { [dataOptions]: '' } : {};
  return (
    <Button
      ref={ref as any}
      variant={variant}
      type={type ?? 'button'}
      data-active={active ? '' : undefined}
      disabled={disabled}
      {...newDataOptions}
      {...props}
    >
      {children}
    </Button>
  );
});
